import type { Novidade } from './tipos';

/** Fase 2 (W21, K13): relatório Margem por serviço (R8) no Relatórios. */
export const novidadeMargem: Novidade = {
  id: '2026-10-05-margem',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'relatorios',
  permissao: 'relatorios.ver',
  textos: {
    pt: {
      titulo: 'Margem por serviço',
      resumo: 'Veja quanto cada serviço dos contratos rende: receita líquida do desconto, custo, margem e margem %, por período e empresa.',
      passos: [
        'Abra Relatórios > Margem por serviço e escolha o período; vale o mês de competência das cobranças de contrato emitidas.',
        'Cada linha mostra a receita, o custo, a margem e a margem % do serviço, com o total da moeda no fim.',
        'Clique no nome do serviço para ver as cobranças e abrir as faturas do cliente.',
        'Em Todas as empresas, a margem sai por empresa, e Exportar CSV gera a planilha completa.',
      ],
    },
    en: {
      titulo: 'Margin by service',
      resumo: 'See how much each contract service earns: revenue net of the discount, cost, margin and margin %, by period and company.',
      passos: [
        'Open Reports > Margin by service and pick the period; it uses the accrual month of the issued contract charges.',
        "Each line shows the service's revenue, cost, margin and margin %, with the currency total at the end.",
        "Click the service name to see the charges and open the customer's invoices.",
        'Under All companies, the margin is shown by company, and Export CSV creates the full spreadsheet.',
      ],
    },
    es: {
      titulo: 'Margen por servicio',
      resumo: 'Mira cuánto rinde cada servicio de los contratos: ingreso neto del descuento, costo, margen y margen %, por período y empresa.',
      passos: [
        'Abre Informes > Margen por servicio y elige el período; vale el mes de devengo de los cobros de contrato emitidos.',
        'Cada línea muestra el ingreso, el costo, el margen y el margen % del servicio, con el total de la moneda al final.',
        'Haz clic en el nombre del servicio para ver los cobros y abrir las facturas del cliente.',
        'En Todas las empresas, el margen sale por empresa, y Exportar CSV genera la hoja completa.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-margem/margem.webp', '/novidades/2026-10-05-margem/cobrancas.webp', null, null],
  treinamento: { curso: 'novidades' },
  rota: '/relatorios/relatorios/margem',
};
